import React, { useEffect, useState } from 'react';
import { Field } from '@alifd/next';
import { Select, Modal, Form, Input } from '@b-design/fusion';
import store from '@/store';
import { history } from 'ice';
import NameIcon from '../NameIcon';
// import brand from '@/assets/brand.png';
import { queryStringify, historyPush } from '@/utils/url-parse';
import qs from 'query-string';
import Requests from '@/services/request';
import AvatarDropdown from '../AvatarDropdown';
// import { useLocation } from 'ice';
import { getQueryStringArgs, queryPathName } from '@/utils/url-parse';
import { goToDuiba, goHome } from '@/utils/index';
import { LOGO, TITLE } from '@/utils/config';
import { checkPathJurisdiction } from '@/utils/index';
import { fetchUserInfo } from '@/services/user';
import { jumpToPage } from '../../pages/index';
import { getMenuConfig } from '@/menuConfig';
import Button, {promisifyValidate} from '@/components/Button';

import './index.less';
import $i18n from '../../i18n';

const HeaderTitle: React.FC = ({ onMenuReset }) => {
  const pathName = queryPathName();
  const field = Field.useField();
  const { init, getError } = field;
  const [spaceRoleState, spaceRoleDispatcher] = store.useModel('spaceRole');
  const [currentSpace, setCurrentSpace] = useState<any>();
  const [spaceList, setSpaceList] = useState<any[]>([]);
  const [userState, userDispatcher] = store.useModel('user');
  const [editNameVisible, setEditNameVisible] = useState(false);

  const spaceId = getQueryStringArgs().spaceId || qs.parse(window.location.search)?.spaceId;
  useEffect(() => {
    getSpaces();
  }, []);
  // useEffect(() => {
  //   // if (!currentSpace) {
  //   //   return;
  //   // }
  //   spaceRoleDispatcher.updateCharacterInfo({
  //     type: currentSpace?.type || '',
  //     roleList: currentSpace?.roleList || [],
  //     belongSpaceId: currentSpace?.belongSpaceId || '',
  //   });
  // }, [currentSpace?.type, currentSpace?.roleList, currentSpace?.belongSpaceId]);

  // useEffect(() => {
  //   // if (!currentSpace) {
  //   //   return;
  //   // }
  //   spaceRoleDispatcher.updateCharacterInfo({
  //     type: currentSpace?.type || '',
  //     role: currentSpace?.role || '',
  //     belongSpaceId: currentSpace?.belongSpaceId || '',
  //   });
  // }, [currentSpace?.type, currentSpace?.role, currentSpace?.belongSpaceId]);

  useEffect(() => {
    spaceRoleDispatcher.updateCharacterInfo(currentSpace || {});
    window.loggerConfig = Object.assign({}, window.loggerConfig || {}, {
      role: currentSpace?.roleList?.join(','),
    });
  }, [currentSpace]);

  useEffect(() => {
    // 阿里云用户 && 已付费 && 存在默认空间 && 空间名称为空：弹框提示用户填写空间名称
    if (
      userState?.currentUser?.accountSrc === 'aliyun' &&
      userState?.currentUser?.isAliyunPaymentUser &&
      userState?.currentUser?.defaultSpace?.spaceId &&
      !userState?.currentUser?.defaultSpace?.spaceName
    ) {
      setEditNameVisible(true);
    }
  }, [userState]);

  const getSpaces = () => {
    Requests.get('/rest/intercnn/space/query', {
      status: 'ACTIVE',
      pageSize: 1000,
    }).then((data) => {
      if (data?.loginUrl) {
        return;
      }

      const { list = [] } = data || {};
      const newList = list?.map((item) => ({
        ...item,
        roleList: item?.role?.split(',') || [],
        value: item?.spaceId,
        label: item?.name,
      }));
      setSpaceList(newList);

      const _space = newList.find((i) => i.spaceId === spaceId) || newList?.[0] || {};
      // onChangeSpace('', '', _space);
      setCurrentSpace(_space);

      const menuList = getMenuConfig({ ..._space, isUpdate: true }, userState.currentUser);
      const hasPermission = checkPathJurisdiction(menuList, pathName, spaceRoleState);
      if (!hasPermission) {
        jumpToPage(_space, userState);
        return;
      }

      // historyPush(pathName, { spaceId: _space?.spaceId });
      history?.push(
        `${pathName}?${queryStringify(Object.assign({}, getQueryStringArgs() || {}, { spaceId: _space?.spaceId }))}`,
      );
    });
  };

  const onChangeSpace = (_v, _a, item) => {
    setCurrentSpace(item);
    onMenuReset && onMenuReset();
    const menuList = getMenuConfig({ ...item, isUpdate: true }, userState.currentUser);
    historyPush(menuList?.children?.[0]?.path || menuList?.path, { spaceId: item?.spaceId });
  };

  const handleOk = async () => {
    const [errs, vals] = await promisifyValidate(field);
      if (errs) {
        return;
      }

      const res = await Requests.post('/rest/intercnn/space/update', {
        name: vals?.spaceName,
        spaceId,
      });
      if (res) {
        // setEditNameVisible(false);
        // const userInfo = await fetchUserInfo();
        // if (userInfo?.status === 4) {
        //   history?.push('/login?safetyModalVisible=true');
        //   return;
        // }
        // userDispatcher.updateCurrentUser(userInfo);
        location.reload();
      }
  };

  return (
    <div className="header-title">
      <div
        className="left-content"
        style={{ borderRight: spaceList?.length ? '1px solid #f2f3f7' : 'none' }}
      >
        {/* <div className="site-icon">
           <img className="icon" src={siteSettingsState?.logo ? siteSettingsState?.logo : LOGO} />
           <div className="name">
             {$i18n.language === 'zh-CN'
               ? siteSettingsState?.name?.zh_CN
               : siteSettingsState?.name?.en_US}
           </div>
          </div> */}
        <div
          className="home-icon"
          onClick={async () => {
            const userInfo = await fetchUserInfo();
            userDispatcher.updateCurrentUser(userInfo);

            if (!spaceId && userState?.currentUser?.isDuibaUser) {
              window.location.href = `${location.origin}${location.pathname}?${queryStringify({
                spaceId: spaceId || '',
              })}#/duiba`;
              return;
            }
            jumpToPage(currentSpace, userState);
          }}
        >
          <img className="icon" src={LOGO} />
          <span>{TITLE}</span>
        </div>
      </div>
      {spaceList?.length === 1 &&
      currentSpace?.roleList?.length === 1 &&
      currentSpace?.roleList?.includes('AIGC_DESIGNER') ? null : (
        <>
          {currentSpace?.iconPublicUrl ? (
            <img className="space-icon" src={currentSpace?.iconPublicUrl} />
          ) : (
            <NameIcon name={currentSpace?.name} shape="square" />
          )}

          <Select
            className="space-select"
            style={{ width: 160 }}
            dataSource={spaceList}
            itemRender={(v) => v.name}
            value={currentSpace}
            valueRender={(v) => v.name}
            onChange={onChangeSpace}
            popupClassName="b-design-select"
            autoWidth={false}
          />
        </>
      )}

      {/* <div className='space-name'>{currentSpace?.name || ''}</div> */}
      {['/guidance']?.includes(queryPathName()) && (
        <div className="right-container">
          <AvatarDropdown
            onMenuReset={onMenuReset}
            avatar={userState.currentUser.userAvatar}
            name={userState.currentUser.userNick}
          />
        </div>
      )}

      <Modal
        visible={editNameVisible}
        closeMode={[]}
        footer={[
          <Button type="primary" onClick={handleOk} style={{ marginLeft: '8px' }}>
            {$i18n.get({
              id: 'aopf.pages.approvals.version.info.confirm.Ok',
              dm: '确定',
            })}
          </Button>,
        ]}
        title={$i18n.get({ id: 'aopf.component.miniapp.CreateASpace', dm: '创建空间' })}
      >
        <Form style={{ marginTop: '16px' }}>
          <Form.Item
            name={$i18n.get({
              id: 'aopf.pages.approvals.space.name',
              dm: '空间名称',
            })}
          >
            <Input
              placeholder={$i18n.get({
                id: 'aopf.pages.miniapp.settleIn.Space.Name.characters',
                dm: '请输入不超过30个字符的空间名称',
              })}
              style={{ width: '640px' }}
              {...init('spaceName', {
                initValue: '',
                rules: [
                  {
                    maxLength: 30,
                    required: true,
                    message: $i18n.get({
                      id: 'aopf.pages.miniapp.settleIn.Space.Name.characters',
                      dm: '请输入不超过30个字符的空间名称',
                    }),
                  },
                ],
              })}
            />

            <p style={{ fontSize: 12, color: '#c82727' }}>{getError('spaceName') as any}</p>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default HeaderTitle;
